import { render } from "./SignupModal.vue?vue&type=template&id=20035812&scoped=true"
import script from "./SignupModal.vue?vue&type=script&lang=js"
export * from "./SignupModal.vue?vue&type=script&lang=js"

import "./SignupModal.vue?vue&type=style&index=0&id=20035812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20035812"]])

export default __exports__